import React, { useState } from "react";
import { useEffect } from "react";

import InnerHero from "../components/InnerHero";
import ProductFilters from "../components/ProductFilters";
import ProductListing from "../components/ProductListing";
import products from "../data/product";
import Categories from "../components/Categories";

function Products() {
  // scroll animation (one time for home page)
  useEffect(() => {
    const elements = document.querySelectorAll(".fade-up");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");

  const filteredProducts = products.filter((item) => {
    const matchSearch =
      item.productName.toLowerCase().includes(search.toLowerCase()) ||
      item.technicalName.toLowerCase().includes(search.toLowerCase());

    const matchCategory =
      category === "All" || item.category === category;

    return matchSearch && matchCategory;
  });

  return (
    <>
      <InnerHero
        title="Our Products"
        subtitle="A complete portfolio of crop protection, plant nutrition, and growth enhancement solutions designed for Indian agriculture."
        bgImage="/images/img/product-hero.png"
      />
      <Categories />

      <ProductFilters
        search={search}
        setSearch={setSearch}
        category={category}
        setCategory={setCategory}
      />

      <ProductListing products={filteredProducts} />

    </>
  );
};

export default Products;
